var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_112_620)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_112_620",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_112_620",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_112_620",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC/UlEQVR4nO3cSatcRRQA4NKoGBcKalQQhxDdiguRiAZENOjCpbMLQSWgC/+CS4lgFDUE0ZXDHxDcuJKokTjiGJ4R3AVMNBHBKeonxa2FiFHe8/Wt6qrzwd10N3SfQ3V19alzK6UQQgghhBBCCKuHy/AwXsEH+Ba/lutIeSw/9xC2rOEtxoVTcA/etnpv4W5sqB1H03AzVvx/B7C9djzNwRl43vp7Dhtrx9cEnIf3Lc672JRGZkpy/pov2oFhk22aLhY5kv9pZJ+eRmMxc/J/2ZNGgu3quSUNtE5eqZjoL4ZYZ+Ne9d2Zeod9tbOMN9MAtYsW/IHNqVemAlErdqRemSptrXgp9Qofasd7qVemGnIrvkm9wi/a8XPqlcakXmlM6pXGpF6JOXoeYtUxD7GOngde1o4XU69MjS6t6LrWsaVUzmrLn+HS1DNr60Bab3tT70wtW7XdnnqHDTP1cpzIZ0PsGWa4qWKib0gjMfXFzW13Gg02lu6hubwzZKdSlvvhZpqvcy/HuWlkpmTvX/BIHrPB8QTTyJ4FJHn3sNPFv8GN5Wu+Hku4sVYXa1xn35W7iVb5dz2/di/uwMm141gq2JyLP7kHo/RSHymbB/k6nEud5bkd3dcuQgghhBBCCGEYOAvX4EE8iddKBS6XUw/hp3IdKnWRfeU1u/AAtuLM2nE0BxeUDdsX8JX1c7DcnZvrJuenEeFK7MSn5pELTh/jMVyReoaL8Ug5nqe2XEZ9FJenXuA6vNpIh9Lf5c/0Om7FSWnZ4DTcj08sj49wH05Ny6CMji8trxXc1uwIx9VlV6QXb+Cq1NixEPmH5Tf9+R1PVZ9O8vZROWuud/vzgQG1knw9jhnHUWybO8nbyt/g0fyIa+dK8jllB3pUh3H2HIl+onakDXh8jkTXPHiqFZ/Pkeg8T43uhzkS/XXtKBtwcI5EP107ygbsmiPRF+I74zqGixae6L/c7PO98RydvR24dHo+W1Yhx/XreInxGVwya5JDCCGEEEIIIYQQUpv+BAvyywawutiQAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserActive);
export default __webpack_public_path__ + "static/media/User-active.005e678f9af222b6b28cad7001b09bbf.svg";
export { ForwardRef as ReactComponent };